<template>
  <div class="user-qr-dialog-content">
    <div class="h-100 overflow-y-auto">
      <!-- Standard layout (with tabs, edit profile icon, birthday/email/phone info) -->
      <template v-if="layout === 'standard'">
        <div>
          <template v-if="$store.state.theme.display_profile_complete == '1'">
            <div class="progress-bar-circle shadow-sm" id="circle-progress-2">
              <div
                v-if="resolvedUserProfile.pictureUrl"
                class="profile-img"
                v-bind:style="{
                  backgroundImage:
                    'url(' + resolvedUserProfile.pictureUrl + ')'
                }"
              ></div>
              <div
                v-else-if="profile.picture"
                class="profile-img"
                v-bind:style="{
                  backgroundImage: 'url(' + profile.picture + ')'
                }"
              ></div>
              <div v-else class="profile-img default">
                <div class="empty-picture">{{ profile.first_name_th[0] }}</div>
              </div>
            </div>
          </template>
          <template v-else>
            <div
              v-if="resolvedUserProfile.pictureUrl"
              class="profile-img-2"
              v-bind:style="{
                backgroundImage:
                  'url(' + resolvedUserProfile.pictureUrl + ')'
              }"
            ></div>
            <div
              v-else-if="profile.picture"
              class="profile-img-2"
              v-bind:style="{
                backgroundImage: 'url(' + profile.picture + ')'
              }"
            ></div>
            <div v-else class="profile-img-2 default">
              <div class="empty-picture">{{ profile?.first_name_th[0] }}</div>
            </div>
          </template>

          <div class="text-center">
            <div class="f-bold">
              {{ profile.first_name_th }} {{ profile.last_name_th }} ({{
                profile.member_id
              }})
              <font-awesome-icon
                @click="onGotoProfile"
                :icon="['fas', 'pencil-alt']"
                class="icon-edit-profile f-body-lg"
                data-test="qr-user-edit-profile-btn"
              />
            </div>
          </div>
          <div class="f-body-lg text-center">
            <font-awesome-icon
              :icon="['fas', 'birthday-cake']"
              class="icon-color-gray"
            />
            <span class="pl-2 profile-ft-color">{{
              profile.have_year_birth === false
                ? dateFormat(profile.birthday, "DD/MM")
                : dateFormat(profile.birthday, "DD/MM/YYYY")
            }}</span>
          </div>
          <div class="f-body-lg text-center">
            <font-awesome-icon
              :icon="['far', 'envelope']"
              class="icon-color-gray"
            />
            <span class="pl-2 profile-ft-color">{{
              profile.email || "-"
            }}</span>
          </div>
          <div class="f-body-lg text-center">
            <font-awesome-icon
              :icon="['fas', 'phone-alt']"
              class="icon-color-gray"
            />
            <span class="pl-2 profile-ft-color">
              {{ convertTelePhone(profile.telephone) || "-" }}
            </span>
          </div>

          <v-tabs v-model="tabIndex" grow class="ignore-bg">
            <v-tab value="2" data-test="qr-user-qrcode-tab">
              {{ $t("qr_code") }}
            </v-tab>
            <v-tab value="1" data-test="qr-user-barcode-tab">
              {{ $t("barcode") }}
            </v-tab>
          </v-tabs>

          <v-window v-model="tabIndex">
            <v-window-item class="p-3 text-center" value="2">
              <qrcode-vue
                class="qr-width-50"
                :value="qrValue"
                render-as="svg"
                background="transparent"
              />
            </v-window-item>
            <v-window-item class="p-3 text-center" value="1">
              <Barcode :value="qrValue" />
            </v-window-item>
          </v-window>
          <div class="timer-countdown" v-if="displayCountdown">
            <div>{{ $t("qr_count_time") }}</div>
            <div>
              {{ countTime }}
            </div>
          </div>
        </div>
        <c-btn
          block
          variant="confirm-primary"
          @click="onClose"
          data-test="qr-user-close-btn"
        >
          {{ $t("close_window") }}
        </c-btn>
      </template>

      <!-- New layout -->
      <template v-else-if="layout === 'new-layout'">
        <div>
          <template v-if="$store.state.theme.display_profile_complete == '1'">
            <div class="progress-bar-circle shadow-sm" id="circle-progress-2">
              <div
                v-if="resolvedUserProfile.pictureUrl"
                class="profile-img"
                v-bind:style="{
                  backgroundImage:
                    'url(' + resolvedUserProfile.pictureUrl + ')'
                }"
              ></div>
              <div
                v-else-if="profile.picture"
                class="profile-img"
                v-bind:style="{
                  backgroundImage: 'url(' + profile.picture + ')'
                }"
              ></div>
              <div
                v-else
                class="profile-img"
                v-bind:style="{
                  backgroundImage: 'url(' + pictureProfile + ')'
                }"
              ></div>
            </div>
            <div
              class="box shadow-sm"
              v-if="$store.state.completeProfile.profile != 100"
              @click="onFillProfile"
              data-test="qr-user-new-layout-fill-profile-btn"
            >
              <div class="point-box">
                {{ Math.round($store.state.completeProfile.profile) }}%
              </div>
              <div>
                <span class="f-bold">
                  <span data-lang="complate_profile">
                    {{ $t("complate_profile") }}
                  </span>
                  :
                  {{
                    Math.round($store.state.completeProfile.profile)
                  }}%</span
                >
                <br />
                {{ $store.state.theme.profile_complete_description }}
              </div>
            </div>
          </template>
          <template v-else>
            <div
              v-if="resolvedUserProfile.pictureUrl"
              class="profile-img-2"
              v-bind:style="{
                backgroundImage:
                  'url(' + resolvedUserProfile.pictureUrl + ')'
              }"
            ></div>
            <div
              v-else-if="profile.picture"
              class="profile-img-2"
              v-bind:style="{
                backgroundImage: 'url(' + profile.picture + ')'
              }"
            ></div>
            <div
              v-else
              class="profile-img-2"
              v-bind:style="{
                backgroundImage: 'url(' + pictureProfile + ')'
              }"
            ></div>
          </template>
          <div class="text-center">
            <div class="f-bold f-title">
              {{ profile.first_name_th }} {{ profile.last_name_th }}
            </div>
          </div>
          <div class="f-body-lg text-center">
            <span class="pl-2 profile-ft-color">{{ profile.member_id }}</span>
          </div>

          <div class="text-center">
            <qrcode-vue
              class="qr-width-70"
              :value="
                qrType == 'Telephone' ? profile.telephone : profile.member_id
              "
              render-as="svg"
              background="transparent"
            />
          </div>
          <div class="timer-countdown" v-if="displayCountdown">
            <div data-lang="qr_count_time">{{ $t("qr_count_time") }}</div>
            <div>
              {{ countTime }}
            </div>
          </div>
        </div>
        <c-btn
          block
          variant="confirm-primary"
          @click="onClose"
          data-test="qr-user-new-layout-close-btn"
        >
          {{ $t("close_window") }}
        </c-btn>
      </template>
    </div>
  </div>
</template>

<script>
import ImageProfile from "@/components/profile/ImageProfile";
import picture from "@/assets/images/default-image.png";
import Barcode from "@/components/other/Barcode.vue";
let countdownInterval;
export default {
  name: "UserQRDialogContent",
  components: {
    ImageProfile,
    Barcode
  },
  props: {
    profile: { type: Object, required: true },
    userProfile: { type: Object, default: () => ({}) },
    layout: { type: String, default: "standard" },
    isBottomSheet: { type: Boolean, default: false }
  },
  emits: ["action", "close"],
  data() {
    return {
      pictureProfile: picture,
      countTime: "00:00",
      displayCountdown:
        this.$store.state.theme.line_display_code_countdown == "1",
      tabIndex: this.$config.line_setting_primary_code || 2,
      qrType: this.$store.state.theme.qr_code,
      internalUserProfile: {}
    };
  },
  computed: {
    qrValue() {
      return this.qrType == "Telephone"
        ? this.profile.telephone || this.profile.member_id
        : this.profile.member_id;
    },
    resolvedUserProfile() {
      if (this.userProfile && Object.keys(this.userProfile).length > 0) {
        return this.userProfile;
      }
      return this.internalUserProfile;
    }
  },
  mounted() {
    this.countTimer();
    this.$nextTick(() => {
      this.internalUserProfile = this.$config.isLoginLine
        ? this.$cookies.isKey("user_profile_token")
          ? this.$cookies.get("user_profile_token")
          : this.$store.state.userProvider
        : {};
      if (this.$store.state.theme.display_profile_complete == "1") {
        let bodyStyles = document.body.style;
        bodyStyles.setProperty(
          "--count-progress-2",
          Math.round(this.$store.state.completeProfile.profile)
        );
        const el = document.getElementById("circle-progress-2");
        if (el) {
          el.setAttribute(
            "count",
            Math.round(this.$store.state.completeProfile.profile)
          );
          el.style.display = "block";
        }
      }
    });
  },
  beforeUnmount() {
    clearInterval(countdownInterval);
  },
  methods: {
    onClose() {
      clearInterval(countdownInterval);
      this.$emit("close");
    },
    onFillProfile() {
      this.$emit("action", {
        action: "fillProfile",
        route: "/edit-profile-required"
      });
    },
    onGotoProfile() {
      this.$emit("action", {
        action: "gotoProfile",
        route: "/manage/profile"
      });
    },
    countTimer() {
      function padZero(value) {
        value = String(value);
        return value.length == 1 ? "0" + value : value;
      }
      var countDownDate = this.$moment().add(10, "minutes").valueOf();
      countdownInterval = setInterval(() => {
        var now = this.$moment().valueOf();
        var distance = countDownDate - now;
        var minutes = padZero(
          Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
        );
        var seconds = padZero(Math.floor((distance % (1000 * 60)) / 1000));

        if (distance < 0) {
          return clearInterval(countdownInterval);
        }
        this.$nextTick(() => {
          this.countTime = minutes + " : " + seconds;
        });
      }, 900);
    },
    dateFormat(value, format) {
      if (!value) return "-";
      return this.$dateFormat(value, format);
    },
    convertTelePhone(val) {
      if (!val) return null;
      return `${val.substring(0, 3)}-${val.substring(3, 6)}-${val.substring(
        6,
        10
      )}`;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../profile/modal/scss/index";
.profile-img-2 {
  width: 150px;
  height: 150px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border: 1px solid black;
  border-radius: 50%;
  margin: 1rem auto;
}
.qr-width-50 {
  width: 50% !important;
  height: 50% !important;
  padding: 0.5rem 0;
}
.qr-width-70 {
  width: 80% !important;
  height: 80% !important;
  padding: 0.5rem 0;
}
.profile-img.default {
  background-color: var(--primary-color);
  color: var(--font-primary-color);
  left: 6px !important;
  top: 6px !important;
}
.profile-img-2.default {
  background-color: var(--primary-color);
  color: var(--font-primary-color);
  left: 6px !important;
  top: 6px !important;
}
</style>
